import React, { useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { Routes, Route, useNavigate } from 'react-router-dom';
import ErrorPage from './error-page';
import Home from './Home';
import About from './About';
import Admin from './Admin';
import NavMenu from './Nav';
import Footer from './Footer';
import Collection from './Collection';
import './GlobalStyles.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const DEFAULT_COLLECTION = 'starwars';
const HOME_PATH = '/';

function App() {
  const navigate = useNavigate();
  const [collection, setCollection] = useState(DEFAULT_COLLECTION);

  const handleNavClick = useCallback((collectionType) => {
    setCollection(collectionType);
    
    if (window.location.pathname !== HOME_PATH) {
      navigate(HOME_PATH);
    }
  }, [navigate]);

  return (
    <React.StrictMode>
      <div className="app" style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        minHeight: '100vh',
        position: 'relative'
      }}>
        <Helmet>
          <title>Collectables - Premium Collection Showcase</title>
          <link rel="icon" type="image/png" href="/images/favicon.jpg" sizes="16x16" />
          <meta name="description" content="Discover an extraordinary showcase of vintage Star Wars treasures, rare Pokemon cards, exclusive Funko Pops, and timeless collectibles. Each piece tells a story." />
          <meta name="keywords" content="collectibles, Star Wars, Pokemon, Funko Pop, vintage toys, rare cards" />
          <meta name="author" content="Ashworth Collection" />
          <meta property="og:title" content="Collectables - Premium Collection Showcase" />
          <meta property="og:description" content="Discover an extraordinary showcase of vintage collectibles and rare treasures." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={window.location.href} />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        
        <NavMenu onNavClick={handleNavClick} />
        
        <main className="main-content" role="main" style={{
          flex: 1,
          position: 'relative',
          zIndex: 1,
          backdropFilter: 'blur(10px)',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '30px 30px 0 0',
          margin: '20px 20px 0 20px',
          boxShadow: '0 -20px 60px rgba(0, 0, 0, 0.1)'
        }}>
          <Routes>
            <Route path={HOME_PATH} element={<Home collection={collection} />} />
            <Route path="/about" element={<About />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/:collectionName/:collectionId" element={<Collection />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </React.StrictMode>
  );
}

export default App;